import api from "../config/api";
import {tencentContainerMap} from "../config/tencentContainerMap";
import noAdBgcSrcList from "../config/noAdBgcSrcList"

export default {
    name: "pubAd",
    props: {
        type: {
            default: "web",
        },
        gooconfig: {
            default: "1",
        },
        position: {//广告位置
            default: "",
        },
        propsheight: {
            default: "90",
        },
        propsWidth: {//百度谷歌响应式需要初始宽度
            default: 300,
        },
        portconfig: {
            default: "true",
        },
        tencentid: {//百度广告数据
            default: "",
        },
        allType: {// 是否为合一的ad，为1，不发网络请求，从本地获取，为0，单独通过position发送请求获取广告数据
            default: 0
        },
        googleDataAdClient: {//谷歌广告数据
            default: 'ca-pub-3179016792556792'
        },
        googleDataAdSlot: {//谷歌广告数据
            default: ''
        },
        isResponsive: {//宽高是否为响应式
            default: false,
        },
        noAdImgIndex: {//没有广告是否展示图片，
            default: -1
        }
    },
    data() {
        return {
            link: "",
            imgSrc: "",
            source: 0, // 来源：0未确定，1本地，2第三方,3其他操作
            defaultSource: 2,//改变该变量可以一键切换广告类型
            // noAdBgcSrcLists:noAdBgcSrcList,//广告背景列表
            noAdImageSrc: null,
            baiduAdContainer: '',
            adData: [], // 广告的内容
            adItem: null, // 单独一个广告内容
        };
    },
    methods: {
        /***
         * 展示谷歌广告位
         * */
        showGooAd() {
            setTimeout(() => {
                if (window.adsbygoogle) {
                    (adsbygoogle = window.adsbygoogle || []).push({});
                }
            });
        },
        /***
         * 展示百度广告位
         * */
        showTencentAd() {
            try {
                this.baiduAdContainer = tencentContainerMap.get(this.tencentid)
                setTimeout(() => {
                    (window.slotbydup = window.slotbydup || []).push({
                        id: this.tencentid,
                        container: this.baiduAdContainer,
                        async: true,
                    });
                });
            } catch (e) {
                this.baiduAdContainer = this.tencentid
                setTimeout(() => {
                    (window.slotbydup = window.slotbydup || []).push({
                        id: this.tencentid,
                        container: this.baiduAdContainer,
                        async: true,
                    });
                });
            }
        },
        /**
         * 进行广告详情的跳转
         * */
        openAdDetail() {
            //增加滁州联通点击埋点
            let data = this.$root.adAllData
            this.showAdStatistics(data)
            this.adClickMaiDian(this.adItem)
            if (this.source === 3) {
                api.postBuriedPointUrl({
                    source: "www",
                    operate: "index-left-5g",
                });
                app.$root.fiveAlterAdSwitch = true;
            } else if (this.source === 1) {
                window.open(this.link);
            } else if (this.source === 6) {
                this.$root.showVideoCollection = true
            }
        },

        /*滁州联通弹窗*/
        showAdStatistics(data) {
            if (data && data.index_top_right && data.index_top_right.length) {
                let index_top_right = data.index_top_right[0]
                if (index_top_right && index_top_right.content) {
                    //调用埋点接口
                    api.buriedPointV3({
                        source: 'www',
                        position: 'www_home_freetest_ahcz_click',
                        type: "click",
                    })
                    return
                }
            }
            api.buriedPointV3({
                source: "www",
                type: "click",
                position: this.position
            })
        },
        /**
         * 对广告内容进行封装
         * */
        handleAd(adRes) {
            this.adData = adRes;
            if (adRes.length) {
                this.link = adRes[0].link;
                this.imgSrc = adRes[0].image;
                this.source = +adRes[0].source;
                this.adItem = adRes[0]
            }
            if (this.source === 4 && !!this.tencentid) {
                this.showTencentAd();
            } else if (this.source === 2 || this.source === 4) {
                this.showGooAd();
            }
        },

        /**
         * 获取广告内容
         * */
        async queryAd() {
            if (+this.allType) {
                return;
            }
            let adRes = [];
            if (this.portconfig === "true" && this.position) {
                try {
                    let response = await api.getAd({type: this.type, position: this.position});
                    if (response.data.length) {
                        adRes = response.data;
                    } else {
                        this.source = this.defaultSource;
                    }
                } catch (e) {
                    this.source = this.defaultSource;
                }
            } else {
                this.source = this.defaultSource;
            }
            this.handleAd(adRes);
        },
        /**
         * 谷歌,百度广告响应式
         * */
        changeADSize() {
            let adWidth = this.$refs.adBoxContainer.clientWidth
            if (this.source === 2) {
                this.$refs.googleIndexAdLeft.style.transform = `scale(${adWidth / this.propsWidth})`
            } else if (this.source === 4) {
                this.$refs.baiduIndexAdLeft.style.transform = `scale(${adWidth / this.propsWidth})`
            }
        },
        // 光告展示埋点
        adMaiDian() {
            let item = this.adItem
            if(item.content){
                this.$initUMeng.buriedPointUm(`web_${item.content}_show`)
            }
        },
        //光告点击埋点
        adClickMaiDian(item) {
            if(item.content){
                this.$initUMeng.buriedPointUm(`web_${item.content}_click`)
            }
        }
    },
    mounted() {
        this.queryAd();
    },
    computed: {
        /**
         * 是否展示广告
         * */
        isCloseAd() {
            let positionArray = ['index_left1', 'index_left2', 'index_left', 'index_right', 'index_right1', 'index_right2']
            let sourceArray = [2, 4]
            return this.$root.isAdFree && (sourceArray.includes(this.source) || positionArray.includes(this.position))
        },
        noAdBgcSrcLists() {
            return noAdBgcSrcList;
        }
    },
    watch: {
        '$root.adAllData': {
            handler: function (val) {
                if (!(+this.allType) || !val) {
                    return;
                }
                let adRes = val[this.position];
                this.handleAd(adRes);
            },
            deep: true,
            immediate: true
        },
        source: {
            handler() {
                if (!this.isCloseAd && this.isResponsive) {
                    //谷歌广告
                    this.$nextTick(() => {
                        this.changeADSize()
                        window.addEventListener('resize', this.changeADSize)
                    })
                }
            },
            immediate: true
        }
    },
    beforeDestroy() {
        if (!this.isCloseAd && this.isResponsive) {
            window.removeEventListener('resize', this.changeADSize)
        }
    },
};



// WEBPACK FOOTER //
// ./resources/js/mixin/pubAdMixins.js